import { MsalService } from '@azure/msal-angular';
import { AppConfigService } from '../../services/appConfigService';
import { lastValueFrom } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class TokenCacheService {
    private cache = new Map<string, { token: string; expiresAt: number }>();
    private refreshInProgress = new Map<string, Promise<string>>();

    constructor(private authService: MsalService,
        private environment: AppConfigService
    ) { }

    async getTokenForDomain(domain: string): Promise<string> {
        const cached = this.cache.get(domain);

        // If cached and not expired, return it
        const SAFETY_WINDOW = 60 * 1000; // 1 minute
        if (cached && cached.expiresAt - SAFETY_WINDOW > Date.now()) {
            return cached.token;
        }

        // If a refresh is already happening, wait for it
        if (this.refreshInProgress.has(domain)) {
            return this.refreshInProgress.get(domain)!;
        }

        // Otherwise, start a new refresh
        const refreshPromise = this.refreshToken(domain);
        this.refreshInProgress.set(domain, refreshPromise);

        try {
            const token = await refreshPromise;
            return token;
        } finally {
            this.refreshInProgress.delete(domain);
        }
    }

    private async refreshToken(domain: string): Promise<string> {

        let userDetails = this.authService.instance.getAllAccounts();
        if (userDetails.length === 0) {
            await this.authService.loginRedirect();
            return "";
        }
        var Api_Scope = this.environment.config.DATA.API_SCOPE.FINANCE_INTEGRATION_APISCOPE;

        if (domain === "accesstokenfinanceintegration") {
            Api_Scope = this.environment.config.DATA.API_SCOPE.FINANCE_INTEGRATION_APISCOPE;
        }
        else if (domain === "accesstokencrmintegration") {
            Api_Scope = this.environment.config.DATA.API_SCOPE.CRM_INTEGRATION_APISCOPE;
        }
        else if (domain === "accesstokenengageapi") {
            Api_Scope = this.environment.config.DATA.API_SCOPE.ENGAGE_API_APISCOPE;
        }
        else if (domain === "accesstokenintegrationapi") {
            Api_Scope = this.environment.config.DATA.API_SCOPE.INTEGRATION_API_APISCOPE;
        }
        else {
            Api_Scope = this.environment.config.DATA.API_SCOPE.CRM_INTEGRATION_APISCOPE;
        }

        const result = await lastValueFrom(
            this.authService.acquireTokenSilent(
                {
                    scopes: [Api_Scope],
                    account: userDetails[0]

                })
        );

        if (!result.expiresOn) {
            throw new Error("Token missing expiresOn");
        }
        const expiresAt = result.expiresOn.getTime();

        this.cache.set(domain, {
            token: result.accessToken,
            expiresAt
        });

        return result.accessToken;
    }
}


